export const SPORTSBOOK_SCRIPT_ID = 'bcsportsbook';
export const SPORTSBOOK_PORTLET_NAME = 'sportsbook-betconstruct';
export const SPORTSBOOK_HTML_CONTAINER_ID = 'bcsportsbookcontainer';
export const SPORTSBOOK_URL_TEMPLATE_TYPE = 'sportsbookBetconstructURL';
